export default "__VITE_ASSET__$ybg_L6m__"